// extracted by mini-css-extract-plugin
export var card = "DefaultReviewCard-module--card--e83b3";
export var fadeInAnimation = "DefaultReviewCard-module--fadeInAnimation--56f97";
export var icon = "DefaultReviewCard-module--icon--1e842";
export var iconWrapper = "DefaultReviewCard-module--iconWrapper--260ea";
export var link = "DefaultReviewCard-module--link--84668";
export var rating = "DefaultReviewCard-module--rating--3a7d2";
export var right = "DefaultReviewCard-module--right--323ec";
export var text = "DefaultReviewCard-module--text--b530c";
export var title = "DefaultReviewCard-module--title--7f431";
export var titleRow = "DefaultReviewCard-module--titleRow--8b082";